import CurrencyText from "../../../../../components/fragment/cur-text/CurrencyText";
import { RazorToggleSlide } from "../../../../../components/razor-reuse";
import type { CurrencyToggleState } from "../vendorControlHelpers";

interface CurrencyToggleRowProps {
  idPrefix: string;
  label: string;
  field: "business" | "direct";
  currencies: CurrencyToggleState[];
  isEditing: boolean;
  onToggle: (code: string, next: boolean) => void;
}

export default function CurrencyToggleRow({
  idPrefix,
  label,
  field,
  currencies,
  isEditing,
  onToggle,
}: CurrencyToggleRowProps) {
  return (
    <div>
      <p className="text-[13px] font-medium text-[#1E1E1E]">{label}</p>
      <div className="mt-[8px] flex flex-wrap items-center gap-[16px] rounded-[8px] bg-[#F4F4F5] px-[16px] py-[12px]">
        {currencies.length === 0 ? (
          <span className="text-[13px] text-[#A1A1AA]">
            No currencies configured
          </span>
        ) : (
          currencies.map((entry) => (
            <label key={entry.code} className="flex items-center gap-[8px]">
              <CurrencyText currency={entry.code} text={entry.code} imgSize="20px" />
              <RazorToggleSlide
                checked={entry[field]}
                disabled={!isEditing}
                onChange={(e: any) => onToggle(entry.code, e.target.checked)}
                color="black-light"
                id={`${idPrefix}-${field}-${entry.code}`}
              />
            </label>
          ))
        )}
      </div>
    </div>
  );
}
